import { render, staticRenderFns } from "./ActivityUnits.vue?vue&type=template&id=40f98dd8"
import script from "./ActivityUnits.vue?vue&type=script&lang=js"
export * from "./ActivityUnits.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports